"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rgbRegex = /rgb\((.*)\)/i;
exports.hex = /\#[\d|a-z]{3,6}/i;
// toHex sanitize "rgb(0, 0, 0)" | "#000" | "#000000" to "rgba(0, 0, 0, 0)"
function toRgba(color) {
    if (exports.rgbRegex.test(color)) {
        var result = color.match(exports.rgbRegex);
        if (result) {
            return rgbToRgba(result[1]);
        }
    }
    if (exports.hex.test(color)) {
        return hexToRgba(color);
    }
    return color;
}
exports.toRgba = toRgba;
// rgbToHex convert rgb(0, 0, 0) to #rgba(0, 0, 0, 1)
function rgbToRgba(color) {
    var result;
    var split = /\(|\)|,/;
    result = color.split(split).filter(Boolean);
    return "rgba(" + result[0] + ", " + result[1] + ", " + result[2] + ", 1)";
}
exports.rgbToRgba = rgbToRgba;
function transToDecimal(numString) {
    return parseInt(numString, 16);
}
exports.transToDecimal = transToDecimal;
function hexToRgba(hex) {
    var numReg = /[\d|a-f]{2}/gi;
    if (hex.length < 6) {
        numReg = /[\d|a-f]/g;
    }
    var numbers = [];
    var res;
    while ((res = numReg.exec(hex))) {
        var num = res[0];
        numbers.push(transToDecimal(num.length === 1 ? "" + num + num : num));
    }
    return "rgba(" + numbers.join(', ') + ", 1)";
}
exports.hexToRgba = hexToRgba;
//# sourceMappingURL=hex.js.map